import { tagging } from "./tagging"
import { CLEARANCE_CATEGORY_PATHS } from "@/config"

export function isClearanceContext(searchQuery?: string): boolean {
  if (searchQuery && /clearance/i.test(searchQuery)) {
    return true
  }

  if (/\/collections\/clearance(?:\/|$)/i.test(globalThis.location?.pathname ?? "")) {
    return true
  }

  try {
    const categoryPath = tagging.categoryPath()
    if (categoryPath) {
      return CLEARANCE_CATEGORY_PATHS.some(
        p =>
          categoryPath.toLowerCase() === p.toLowerCase() || categoryPath.toLowerCase().endsWith(`/${p.toLowerCase()}`)
      )
    }
  } catch {
    // tagging API not yet initialized — not clearance
  }

  return false
}
